
<template>
  <div>
    <v-row>
      <v-col v-if="!isEmbed" cols="7" class="align-center">
        <h1 v-if="!expediente">{{ $t('marcas_index.title') }}</h1>
      </v-col>

      <v-col :cols="isEmbed ? 12 : 5" style="display: flex; align-items: center;">
        <v-text-field
          v-model="search"
          class="mr-2"
          :label="$t('marcas_index.search_label')"
          :placeholder="$t('marcas_index.search_placeholder')"
          append-icon="mdi-magnify"
          outlined
          dense
          hide-details
          clearable
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn depressed outlined class="mx-2" @click="$router.push((isPortal) ? '/portal/marcas/nueva' : '/marcas/nueva')">
          {{ $t('marcas_index.new_brand') }}
        </v-btn>
      </v-col>

      <v-col cols="12">
        <v-card class="mx-auto">
          <v-data-table
            :headers="[
              { text: '', align: 'start', value: 'status', cellClass: 'subData' },
              { text: $t('marcas_index.brand'), align: 'start', value: 'nombre' },
              { text: $t('marcas_index.date'), align: 'start', value: 'fechas', cellClass: 'subData' },
              { text: $t('marcas_index.own_brand'), align: 'center', value: 'is_propia', cellClass: 'subData', sortable: false },
              { text: $t('marcas_index.label_received'), align: 'center', value: 'is_etiqueta_recibida', cellClass: 'subData', sortable: false },
              { text: $t('marcas_index.label_validated'), align: 'center', value: 'is_etiqueta_validada', cellClass: 'subData', sortable: false },
              { text: $t('marcas_index.on_certificate'), align: 'center', value: 'is_imprimir_en_certificado', cellClass: 'subData', sortable: false },
              { text: '', value: 'actions', align: 'left' }
            ]"
            :items="items"
            :search="search"
            @click:row="rowAction"
          >
            <template v-slot:item.auditor="{ item }">
              <span style="font-size: 0.85rem; color: #929292">
                {{ item.auditor && item.auditor.nombre || "--" }}
              </span>
            </template>

            <template v-slot:item.is_propia="{ item }">
              <span v-if="item.is_propia" style="font-size: 18px">
                ✅
              </span>
            </template>

            <template v-slot:item.is_etiqueta_recibida="{ item }">
              <span v-if="item.is_etiqueta_recibida" style="font-size: 18px">
                ✅
              </span>
            </template>

            <template v-slot:item.is_etiqueta_validada="{ item }">
              <span v-if="item.is_etiqueta_validada" style="font-size: 18px">
                ✅
              </span>
            </template>

            <template v-slot:item.is_imprimir_en_certificado="{ item }">
              <span v-if="item.is_imprimir_en_certificado" style="font-size: 18px">
                ✅
              </span>
            </template>

            <template v-slot:item.fechas="{ item }">
                {{ $moment(item.fecha).format("DD [de] MMMM, YYYY") }}
            </template>

            <template v-slot:item.status="{ item }">
              <v-chip label small outlined>
                {{ item.is_active ? $t('marcas_index.active') : $t('marcas_index.inactive') }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon style="font-size: 20px" color="primary" @click.stop="toDelete(item)">mdi-delete-outline</v-icon>
            </template>

          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <confirmation
        v-model="confirmDelete"
        :text="$t('marcas_index.confirm_delete')"
        colorButton="error"
        @confirm="deleteItem()"/>
  </div>
</template>


<script>
/**
 * @project: certiapp-nuxt
 * @file:    \pages\portal\marcas\index.vue
 * @desc:    ...
 * -------------------------------------------
 * Created Date: 2nd November 2022
 * Last Modified: Fri Apr 28 2023
 **/

import Confirmation from '~/components/Confirmation'

export default {
  name: 'marcas',

  props: {
    isPortal: { type: Boolean, default: false },
    isEmbed: { type: Boolean, default: false },
    expediente: {
      type: Object,
      default: () => ({}),
    },
    cliente: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    Confirmation,
  },

  data() {
    return {
      search: '',
      itemToDelete: {},
      confirmDelete: false,

      user: {},
      client: {},

      db: {
        marcas: [],
      },

      ui: {
        modal: false,
      },
    }
  },

  computed: {
    items() {
      if (this.expediente.uuid)
        return this.db.marcas.filter((m) => m.cliente.uuid == this.expediente.cliente.uuid)

      if (this.cliente.uuid)
        return this.db.marcas.filter((m) => m.cliente.uuid == this.cliente.uuid)

      return this.db.marcas
    },
  },

  methods: {
    rowAction(item) {
      let prefix = this.isPortal ? '/portal' : ''
      this.$router.push(prefix + '/marcas/' + item.uuid)
    },

    toDelete(item) {
      this.confirmDelete = true
      this.itemToDelete = item
    },

    async deleteItem() {
      this.confirmDelete = false
      await this.$store.dispatch('marcas/delete', this.itemToDelete)
      await this.getMarcas()
      this.itemToDelete = {}
    },

    async getMarcas() {
      const xhr = await this.$store.dispatch('marcas/list')
      if (xhr) this.db.marcas = xhr.slice().reverse()
    },

    async init() {
      this.user = this.$auth.user
      this.getMarcas()
    },
  },

  mounted() {
    this.init()
  },
}
</script>

<style scoped>
.form-label {
  font-weight: 500;
  color: #666;
  transform: translateY(9px);
}

.subData {
  color: rgb(146, 146, 146);
  font-size: 12px !important;
  white-space: nowrap;
}

.v-data-table.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
